import type { Action } from 'state/actions';

import type { TilesOrderState } from './orderedTiles.model';

export function orderedTilesReducer(state: TilesOrderState = [], action: Action): TilesOrderState {
  switch (action.type) {
    case 'DASHBOARD_TILE_CREATED':
      return [action.quoteId, ...state];
    case 'DASHBOARD_TILE_DUPLICATED':
      const originalQuoteIndex = state.indexOf(action.originalQuoteId);
      return [...state.slice(0, originalQuoteIndex), action.quoteId, ...state.slice(originalQuoteIndex, undefined)];
    case 'DASHBOARD_TILE_REMOVED':
      return state.filter(quoteId => quoteId !== action.quoteId);
    case 'QUOTES_REMOVED':
    case 'DASHBOARD_OBSOLETE_QUOTES_DELETED':
      return state.filter(quoteId => action.quoteIds.includes(quoteId) === false);
    case 'DASHBOARD_LOADED':
      return [...state, ...action.quoteIds];
    default:
      return state;
  }
}
